export default __webpack_public_path__ + "static/media/NLPSummary.34dcdcb5.png";